var map = {
	"../auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"../pages/company/add-company/add-company.module": [
		"./src/app/pages/company/add-company/add-company.module.ts",
		"pages-company-add-company-add-company-module"
	],
	"../pages/company/detail-company/detail-company.module": [
		"./src/app/pages/company/detail-company/detail-company.module.ts",
		"pages-company-detail-company-detail-company-module"
	],
	"../pages/company/list-company/list-company.module": [
		"./src/app/pages/company/list-company/list-company.module.ts",
		"pages-company-list-company-list-company-module"
	],
	"../pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"../pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;